import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { HiPlus } from "react-icons/hi2";
import { FiCheckCircle, FiEdit2, FiEdit3 } from "react-icons/fi";
import "./AddButton.scss";

export default function AddButton({
  noteTo = "addnote",
  postTo = "/post/new",
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const reducedMotion = useReducedMotion();
  const rootRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const isOpen = location.pathname.split("/").includes("addtask");
  const options = [
    { key: "post", label: "post", to: postTo, Icon: FiEdit3 },
    { key: "note", label: "note", to: noteTo, Icon: FiEdit2 },
    { key: "task", label: "task", to: "addtask", Icon: FiCheckCircle },
  ];

  useEffect(() => {
    if (!menuOpen) return;
    const handleOutside = (event) => {
      if (!rootRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("pointerdown", handleOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("pointerdown", handleOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  function openTask(event) {
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuOpen(false);
    navigate("addtask", {
      state: {
        taskOrigin: {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        },
      },
    });
  }

  return (
    <div ref={rootRef} className="addbutton__root">
      {menuOpen && !isOpen && (
        <motion.div
          className="addbutton__menu"
          initial={reducedMotion ? false : { opacity: 0, y: 10, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: reducedMotion ? 0 : 0.15 }}
          onContextMenu={(event) => event.preventDefault()}
        >
          {options.map(({ key, label, to, Icon }) => (
            <Link
              key={key}
              to={to}
              className="addbutton__option"
              onClick={(event) => {
                if (
                  key === "task" &&
                  event.button === 0 &&
                  !event.metaKey &&
                  !event.ctrlKey &&
                  !event.shiftKey &&
                  !event.altKey
                )
                  openTask(event);
                else setMenuOpen(false);
              }}
            >
              <span className="addbutton__option-btn">
                <Icon size={22} />
              </span>
              <span className="addbutton__option-label">{label}</span>
            </Link>
          ))}
        </motion.div>
      )}
      {/* The real TaskDetail panel expands from this button's rectangle. */}
      <motion.button
        type="button"
        className="addtask__btn"
        initial={false}
        animate={{ opacity: isOpen ? 0 : 1, scale: isOpen ? 0.85 : 1 }}
        transition={{ duration: reducedMotion ? 0 : 0.15 }}
        onClick={openTask}
        onContextMenu={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setMenuOpen((open) => !open);
        }}
        disabled={isOpen}
        style={{ pointerEvents: isOpen ? "none" : "auto" }}
        aria-label="Add task"
      >
        <HiPlus size="2.3em" />
      </motion.button>
    </div>
  );
}
